import { useState } from 'react';

// Guarda el último valor de cada filtro en un mapa en memoria (vive mientras no se recargue
// la página) para que un listado de trámites recuerde los filtros aplicados al volver desde
// el detalle de un trámite (ver useVolverAtras). No es localStorage/sessionStorage a propósito:
// un F5 debe resetear los filtros, y este mapa se pierde con cualquier recarga real de la SPA.
const almacen = new Map();

// Se llama al loguear/desloguear (ver AuthContext) para que un cambio de usuario en la misma
// pestaña no arrastre los filtros del usuario anterior (búsqueda, página) — sin esto, dos
// personas que comparten navegador verían el listado "filtrado" por lo último que tipeó la otra.
export function limpiarFiltrosPersistentes() {
    almacen.clear();
}

export default function useFiltroPersistente(clave, valorInicial) {
    const [valor, setValorState] = useState(() =>
        almacen.has(clave) ? almacen.get(clave) : valorInicial
    );

    const setValor = (nuevoValor) => {
        setValorState((anterior) => {
            const resultado = typeof nuevoValor === 'function' ? nuevoValor(anterior) : nuevoValor;
            almacen.set(clave, resultado);
            return resultado;
        });
    };

    return [valor, setValor];
}
